import { createApp, provide, h } from 'vue'
import App from './App.vue'
import router from './router' // Importa o router

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { pt } from 'vuetify/locale'

// Apollo Client
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { DefaultApolloClient } from '@vue/apollo-composable'

console.log(`[Frontend] Ambiente: ${process.env.NODE_ENV}`)

// Link HTTP para o seu servidor GraphQL (substitua pela URL correta quando tiver)
const httpLink = createHttpLink({
  uri: process.env.VUE_APP_APOLLO_URL, // URL do seu servidor Apollo
})

// Cache do Apollo
const cache = new InMemoryCache()

// Cliente Apollo
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
})

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'pt',
    fallback: 'en', // Adiciona um fallback, uma boa prática
    messages: { pt },
  },
})

// Cria a aplicação, usa os plugins e fornece o cliente Apollo
createApp({
    setup () {
      provide(DefaultApolloClient, apolloClient)
    },
    render: () => h(App),
  })
  .use(router)
  .use(vuetify)
  .mount('#app')
